export default {
    // Header Section
    "discover_your": "Discover Your",
    "gemstones": "Gemstones",
    "healing_crystal_guidance": "Healing Crystal Guidance",
    "gemstones_description": "Receive personalized gemstone and crystal recommendations based on your unique birth chart. Discover the perfect stones for healing, protection, prosperity, and spiritual growth—along with expert guidance on how to choose, wear, and care for them to maximize their benefits.",


    "gemstone_power": "Gemstone Power",
    "unlock_your": "Unlock Your",
    // Service Information
    "enter_details_for_gemstone_analysis": "Enter Your Details for Gemstone Analysis",
    "complete_gemstone_analysis": "Complete Gemstone Analysis",
    "service_price": "Service Price",
    "comprehensive_gemstone_analysis_note": "Personalized gemstone recommendations with planetary analysis and wearing guidance",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_gemstone_resonance": "Your name vibrations help determine gemstone resonance and compatibility",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_planetary_gemstones": "Essential for determining planetary influences and suitable gemstones",
    "time_of_birth": "Time of Birth",
    "exact_time_gemstone_selection": "Precise time needed for accurate planetary strength analysis",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "location_affects_gemstone_energy": "Location influences planetary positions affecting gemstone selection",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your gemstone guide will be delivered in the selected language",

    // Core Gemstone Features
    "personalized_gemstone_recommendations": "Personalized Gemstone Recommendations",
    "planetary_gemstone_analysis": "Planetary Gemstone Analysis",
    "healing_crystal_guidance": "Healing Crystal Guidance",
    "wearing_methods_timing": "Wearing Methods & Timing",
    "gemstone_care_instructions": "Gemstone Care Instructions",
    "pdf_download": "Comprehensive PDF Guide",

    "what_you_get": "What Your Gemstone Analysis Includes",
    "personalized_gemstone_guide": "Personalized Gemstone Guide",
    "planetary_remedial_stones": "Planetary Remedial Stones",
    "healing_crystal_recommendations": "Healing Crystal Recommendations",
    "wearing_activation_guidance": "Wearing & Activation Guidance",

    // Actions & Buttons
    "pay_and_get_gemstone_guidance": "Get My Gemstone Guide",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Guide",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "gemstone_analysis_processing": "Your personalized gemstone analysis is being prepared by our expert gemologists and astrologers. You'll receive detailed recommendations for healing and remedial stones.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Guide Delivery",
    "within_12_hours_delivery_note": "Your detailed gemstone guide will be ready within 12 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete guide delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Gemstone Guide Package",
    "detailed_gemstone_report_pdf": "Detailed Gemstone Report (PDF)",
    "personalized_stone_recommendations": "Personalized Stone Recommendations",
    "planetary_remedial_guidance": "Planetary Remedial Guidance",
    "wearing_activation_methods": "Wearing & Activation Methods",
    "gemstone_care_maintenance": "Gemstone Care & Maintenance",

    // Visual Content
    "sample_gemstone_analysis": "Sample Gemstone Analysis",
    "recommended_gemstone": "Recommended Gemstone",
    "sample_gemstone_reading": "Blue Sapphire for Saturn strengthening and wisdom enhancement",
    "sample_gemstone_preview": "Preview of your personalized gemstone recommendations with healing properties",
    "gemstone_categories": "Gemstone Categories",

    // Gemstone Types
    "ruby": "Ruby",
    "emerald": "Emerald",
    "sapphire": "Sapphire",
    "diamond": "Diamond",
    "yellow_sapphire": "Yellow Sapphire",
    "coral": "Coral",

    // Status & Processing
    "your_gemstone_analysis_status": "Your Gemstone Analysis Status",
    "processing_your_analysis": "Analyzing Your Gemstone Needs",
    "analysis_processing_message": "Our expert gemologists are studying your birth chart to recommend the most suitable gemstones for healing, protection, and prosperity.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_12_hours": "Guide ready within 12 hours",

    // Support & Contact
    "contact_support": "Contact Gemstone Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required birth details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Planetary Gemstones
    "sun_gemstones": "Sun Gemstones",
    "moon_gemstones": "Moon Gemstones",
    "mars_gemstones": "Mars Gemstones",
    "mercury_gemstones": "Mercury Gemstones",
    "jupiter_gemstones": "Jupiter Gemstones",
    "venus_gemstones": "Venus Gemstones",
    "saturn_gemstones": "Saturn Gemstones",
    "rahu_gemstones": "Rahu Gemstones",
    "ketu_gemstones": "Ketu Gemstones",

    // Primary Gemstones
    "ruby_manik": "Ruby (Manik)",
    "pearl_moti": "Pearl (Moti)",
    "coral_moonga": "Red Coral (Moonga)",
    "emerald_panna": "Emerald (Panna)",
    "yellow_sapphire_pukhraj": "Yellow Sapphire (Pukhraj)",
    "diamond_heera": "Diamond (Heera)",
    "blue_sapphire_neelam": "Blue Sapphire (Neelam)",
    "hessonite_gomed": "Hessonite (Gomed)",
    "cats_eye_lehsunia": "Cat's Eye (Lehsunia)",

    // Secondary Gemstones
    "garnet": "Garnet",
    "moonstone": "Moonstone",
    "carnelian": "Carnelian",
    "peridot": "Peridot",
    "citrine": "Citrine",
    "opal": "Opal",
    "amethyst": "Amethyst",
    "agate": "Agate",
    "onyx": "Onyx",

    // Healing Crystals
    "rose_quartz": "Rose Quartz",
    "clear_quartz": "Clear Quartz",
    "amethyst_crystal": "Amethyst Crystal",
    "citrine_crystal": "Citrine Crystal",
    "black_tourmaline": "Black Tourmaline",
    "green_aventurine": "Green Aventurine",
    "tigers_eye": "Tiger's Eye",
    "labradorite": "Labradorite",
    "fluorite": "Fluorite",

    // Gemstone Properties
    "healing_properties": "Healing Properties",
    "protective_properties": "Protective Properties",
    "prosperity_properties": "Prosperity Properties",
    "spiritual_properties": "Spiritual Properties",
    "emotional_properties": "Emotional Healing Properties",
    "physical_properties": "Physical Healing Properties",

    // Gemstone Selection Criteria
    "planetary_strength": "Planetary Strength Analysis",
    "weak_planets": "Weak Planets Identification",
    "malefic_planets": "Malefic Planets Analysis",
    "benefic_enhancement": "Benefic Planet Enhancement",
    "doshas_correction": "Doshas Correction",
    "yogas_strengthening": "Yogas Strengthening",

    // Quality & Authenticity
    "gemstone_quality": "Gemstone Quality Guidelines",
    "authenticity_check": "Authenticity Verification",
    "certification_importance": "Certification Importance",
    "natural_vs_synthetic": "Natural vs Synthetic Stones",
    "treatment_disclosure": "Treatment & Enhancement Disclosure",
    "origin_significance": "Origin & Source Significance",

    // Wearing Guidelines
    "wearing_finger": "Wearing Finger Guidance",
    "wearing_day": "Auspicious Wearing Day",
    "wearing_time": "Optimal Wearing Time",
    "metal_selection": "Metal Selection for Setting",
    "weight_calculation": "Gemstone Weight Calculation",
    "purification_ritual": "Purification & Activation Ritual",

    // Gemstone Care
    "cleaning_methods": "Cleaning & Maintenance Methods",
    "storage_guidelines": "Proper Storage Guidelines",
    "energizing_techniques": "Re-energizing Techniques",
    "avoid_damage": "Damage Prevention Tips",
    "periodic_cleansing": "Periodic Cleansing Rituals",
    "replacement_timing": "Replacement & Upgrade Timing",

    // Benefits & Effects
    "career_benefits": "Career & Business Benefits",
    "health_benefits": "Health & Wellness Benefits",
    "relationship_benefits": "Relationship & Love Benefits",
    "financial_benefits": "Financial & Prosperity Benefits",
    "spiritual_benefits": "Spiritual Growth Benefits",
    "protection_benefits": "Protection & Security Benefits",

    // Timing & Muhurat
    "auspicious_timing": "Auspicious Purchase Timing",
    "wearing_muhurat": "Wearing Muhurat Calculation",
    "activation_timing": "Activation Ritual Timing",
    "eclipse_precautions": "Eclipse Period Precautions",
    "festival_significance": "Festival & Special Day Significance",
    "monthly_guidelines": "Monthly Wearing Guidelines",

    // Combination Guidelines
    "gemstone_combinations": "Beneficial Gemstone Combinations",
    "conflicting_stones": "Conflicting Stone Combinations",
    "layered_wearing": "Layered Wearing Guidelines",
    "rotation_schedule": "Gemstone Rotation Schedule",
    "seasonal_preferences": "Seasonal Gemstone Preferences",
    "occasion_selection": "Occasion-based Selection",

    // Alternative Options
    "budget_alternatives": "Budget-friendly Alternatives",
    "substitute_stones": "Substitute Stone Options",
    "semi_precious_options": "Semi-precious Alternatives",
    "synthetic_alternatives": "Synthetic Stone Alternatives",
    "crystal_alternatives": "Crystal & Mineral Alternatives",
    "rudraksha_combinations": "Rudraksha Combinations",

    // Special Categories
    "bridal_gemstones": "Bridal Gemstone Selection",
    "childrens_gemstones": "Children's Gemstone Guidelines",
    "elderly_recommendations": "Elderly-specific Recommendations",
    "professional_stones": "Professional & Career Stones",
    "students_gemstones": "Student & Academic Stones",
    "artists_stones": "Creative & Artistic Stones",

    // Astrological Factors
    "ascendant_stones": "Ascendant-based Stone Selection",
    "moon_sign_stones": "Moon Sign Gemstone Guidance",
    "sun_sign_influence": "Sun Sign Influence on Selection",
    "navamsa_considerations": "Navamsa Chart Considerations",
    "dasha_period_stones": "Dasha Period Specific Stones",
    "transit_considerations": "Current Transit Considerations",

    // Consultation Features
    "expert_consultation": "Expert Gemologist Consultation",
    "follow_up_guidance": "Follow-up Guidance Available",
    "customization_options": "Customization & Personalization",
    "update_recommendations": "Updated Recommendations",
    "progress_tracking": "Benefits Progress Tracking",
    "adjustment_guidance": "Adjustment & Fine-tuning",

    // Regional Preferences
    "indian_gemstones": "Indian Origin Gemstones",
    "burmese_stones": "Burmese Origin Stones",
    "ceylon_sapphires": "Ceylon Sapphire Specialty",
    "kashmir_sapphires": "Kashmir Sapphire Premium",
    "colombian_emeralds": "Colombian Emerald Excellence",
    "african_gemstones": "African Origin Gemstones",

    // Modern Applications
    "technology_enhancement": "Technology & Digital Life Enhancement",
    "stress_relief": "Modern Stress Relief Solutions",
    "urban_living": "Urban Living Gemstone Needs",
    "travel_protection": "Travel & Journey Protection",
    "workspace_harmony": "Workplace Harmony Stones",
    "social_confidence": "Social Confidence Boosters"
};
